import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Auth } from '@angular/fire/auth'
import { addDoc, collection, collectionData, Firestore, orderBy, query, serverTimestamp } from '@angular/fire/firestore'

import { Note, NoteWithId } from '@innersight-os/shared/firestore-interfaces'
import { DocumentData } from '@firebase/firestore-types'


@Injectable({
  providedIn: 'root'
})
export class NotesService {
  constructor(
    private auth: Auth,
    private db: Firestore,
  ) {}

  getNotes = (operationId: string): Observable<NoteWithId[]> =>
    collectionData(
      query<NoteWithId, DocumentData>(
        // eslint-able-next-line @typescript-eslint/no-explicit-any
        collection(this.db, `operations/${operationId}/notes`) as any,
        orderBy('createdAt', 'asc')
      ),
      {idField: 'id'},
    ) as Observable<NoteWithId[]>

  createNote = async (note: Omit<Note, 'createdAt' | 'createdBy'>) =>
    addDoc(
      collection(
        this.db,
        `operations/${note.operationId}/notes`
      ),
      {
        ...note,
        ...this.createdFields(),
      }
    )

    private createdFields = () => ({
      createdAt: serverTimestamp(),
      createdBy: this.auth.currentUser.uid,
    })
}
